import PropTypes from "prop-types";

export function P({ data }) {
  return <p className="font-normal font-neue">{data}</p>;
}

P.propTypes = {
  data: PropTypes.string.isRequired,
};
